import { Menu } from '@mui/material';
import React, { useState } from 'react';
import styles from '../customTabs.module.css';
import { Box, Checkbox, MenuItem } from '@mui/material';
import { GetFormatTitle } from '../../tableComponent/getTableColumn/getFormattedData';
import { APPLICATION_DETAILS_LABEL_MAP, APPLICATION_DETAILS_TBL_LABEL_MAP } from '../../../utils/constants/applicationDetailsBifurcation';
import CustomTabsStyles from '../CustomTabsStyles';
import { Input } from 'antd';


interface ColumnsListCheckBoxProps {
  anchorEl: HTMLElement | null;
  handleMenuClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
  AllBoxSelected: boolean;
  handleUnselectApp: () => void
  handleSelectAll: () => void
  handleColumnToggle: (columnId: string) => void;
  TotalTableInfo: string[]
  fixedColumns: string[]
  isColumnVisible: (columnId: string) => boolean | null
}

const ColumnsListCheckBox: React.FC<ColumnsListCheckBoxProps> = (props) => {
  const { anchorEl,
    handleMenuClose,
    AllBoxSelected,
    handleUnselectApp,
    handleSelectAll,
    handleColumnToggle,
    TotalTableInfo,
    fixedColumns,
    isColumnVisible
  } = props;

  const {
    checkboxStyles,
  } = CustomTabsStyles().classes;

  const [filterText, setFilterText] = useState('');

  const getFilteredColumns = (column: string) => {
    // Remove all spaces from the column name and convert to lowercase for case-insensitive search
    return column.replace(/\s+/g, '').toLowerCase();
  }

  const getColumnLabel = (column: string) => {
    return APPLICATION_DETAILS_TBL_LABEL_MAP[column] ?? APPLICATION_DETAILS_LABEL_MAP[column] ?? GetFormatTitle(column);
  }

  return (
      <Menu
        id="column-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        classes={{ paper: styles.menuPaper }}
        className={styles.menuOuter}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box className={styles.menuBox}>
          <Box className={styles.menuItemTitleCtn}>
            <span className={styles.titleTxt}>
              Column Settings
            </span>
            <span
              className={styles.selectAllTxt}
              onClick={
                AllBoxSelected ?
                  handleUnselectApp :
                  handleSelectAll}
            >
              {AllBoxSelected ? 'Unselect All' : 'Select All'}
            </span>
          </Box>
          <Box className={styles.searchBarCtn}>
            <Input
              placeholder="Filter columns..."
              allowClear
              onKeyDown={(e) => e.stopPropagation()}
              onChange={(e) => setFilterText(e.target.value.toLowerCase())}
            />
          </Box>
        </Box>
        <Box
          className={styles.optionCtn}
        >
          {TotalTableInfo.filter(column => {
            const query = getFilteredColumns(filterText);
            const keyMatch = column.toLowerCase().includes(query);
            const labelMatch = getFilteredColumns(getColumnLabel(column)).includes(query);
            return keyMatch || labelMatch;
          }).map((column) => (
            <MenuItem key={column} className={styles.menuItem}
              onClick={() => {
                if (!fixedColumns.includes(column)) {
                  handleColumnToggle(column)
                }
              }}>
              <Box className={styles.menuItemInner}>
                <Checkbox
                  checked={isColumnVisible(column) ?? false}
                  disabled={fixedColumns.includes(column)}
                  className={checkboxStyles}
                />
                <span>{ getColumnLabel(column) }</span>
              </Box>
            </MenuItem>
          ))}
        </Box>
      </Menu>
  );
};

export default ColumnsListCheckBox;
